import { useSelector } from 'react-redux';
import { transcriptionBalanceMillisSelector } from 'redux/modules/pricing';
import useBalance, { UseBalanceOptions } from './useBalance';

export type UseTranscriptionBalanceOptions = Omit<
  UseBalanceOptions,
  'balanceMillis'
>;

export default function useTranscriptionBalance(
  options: UseTranscriptionBalanceOptions = {},
) {
  const balanceMillis = useSelector(transcriptionBalanceMillisSelector);

  return useBalance({ ...options, balanceMillis });
}
